/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_Is_DisabledInputs */

const en_tables_pause_reasons_is_disabled = /** @type {(inputs: Tables_Pause_Reasons_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons Is Disabled`)
};

const de_tables_pause_reasons_is_disabled = /** @type {(inputs: Tables_Pause_Reasons_Is_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist deaktiviert`)
};

/**
* | output |
* | --- |
* | "Reasons Is Disabled" |
*
* @param {Tables_Pause_Reasons_Is_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_is_disabled = /** @type {((inputs?: Tables_Pause_Reasons_Is_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_Is_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_is_disabled(inputs)
	return de_tables_pause_reasons_is_disabled(inputs)
});